define(function() {
    var IpsModelCollection = require('civicsBase/ipsModelCollection');
    const saved_searches_model = require('civicsModels/portal/saved_searches');

    return IpsModelCollection.extend({
        model: saved_searches_model,
        urlRoot: '/delegate/civics-api/api/portal/search/list', 
        url: function() {
            var ret = this.urlRoot;
            return ret;
        },
    });
});